import styles from "../../../styles/charts/chartStyle.module.css";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { titleStyler, toShortNumber } from "../../../lib/util";

interface BubbleChartProps {
  chartData: any[];
  legend?: string[];
  xLabel: string;
  yLabel: string;
  zLabel: string;
  title?: string;
  jumpToProposal: Function;
}

const BubbleChart = (props: BubbleChartProps) => {
  const { xLabel, yLabel, zLabel, chartData, jumpToProposal, title } = props;
  let { axisTitleStyle, chartTitleStyle, axisLabelStyle } = titleStyler();
  let series: any[] = [];

  if (props.legend) {
    chartData.forEach((item, index) => {
      series.push({
        name: props.legend![index],
        data: item,
      });
    });
  } else {
    series.push({ data: chartData });
  }

  let options = {
    chart: {
      height: 500,
      type: "bubble",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: xLabel,
            headerValue: yLabel,
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },
      events: {
        click: (event: any, chartContext: any, config: any) =>
          jumpToProposal(
            config.config.series[config.seriesIndex].data[config.dataPointIndex]
              .p_id
          ),
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 1,
      // type: "gradient",
    },
    title: {
      align: "center",
      style: chartTitleStyle,
    },
    xaxis: {
      tickAmount: 10,
      type: "numeric",
      title: {
        text: xLabel,
        offsetX: 0,
        offsetY: 70,
        style: axisTitleStyle,
      },
      labels: {
        style: axisLabelStyle,
        formatter: toShortNumber,
      },
    },
    yaxis: {
      tickAmount: 7,
      type: "numeric",
      title: {
        text: yLabel,
        offsetY: 0,
        style: axisTitleStyle,
        offsetX: 11,
      },
      labels: {
        style: axisLabelStyle,
        formatter: toShortNumber,
      },
    },
    tooltip: {
      fixed: {
        enabled: true,
        position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60,
      },
      followCursor: true,
      x: {
        title: xLabel,
      },
      y: {
        title: yLabel,
      },
      z: {
        title: zLabel,
      },
    },
    legend: {
      horizontalAlign: "left",
      offsetX: 40,
    },
    noData: {
      text: "Loading...",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
  };

  return (
    <>
      <ReactApexChart
        series={series}
        className={styles.the_chart}
        options={options as unknown as ApexOptions}
        type="bubble"
      />
    </>
  );
};

export default BubbleChart;
